import React, { Fragment, useEffect, useState } from "react";
import { OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { fetchTrainingVideos } from "../../services/orgService";
import "./TrainingVideo.scss";
import { useSelector } from "react-redux";
import { checkSubscriptionPermission } from "../../helper";
import UpgradeMessageDialog from "../Subscription/UpgradeMessageDialog";

const TrainingVideo = () => {
  const { t, i18n } = useTranslation();
  const helpLinks = [
    "https://support.planetwise.io/portal/en/kb/planetwise",
    "https://support.planetwise.io/portal/en/signin",
  ];
  const planPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  const [searchText, setSearchText] = useState("");
  const [allVideos, setAllVideos] = useState<any>([]);
  const [videos, setVideos] = useState<any>([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );
  const [openUpgradeDialog, setOpenUpgradeDialog] = useState(false);

  const onClickSearch = () => {
    setCurrentVideoIndex(null);
    const requestObject: any = {};
    if (searchText?.length) {
      requestObject["searchText"] = searchText;
    }
    fetchVideos(requestObject);
  };

  const onClickCancel = () => {
    setSearchText("");
  };

  const handleHelp = (index: number) => {
    window.open(helpLinks[index], "_blank");
  };

  const onSelectVideo = (index: number) => {
    setCurrentVideoIndex(index);
    if (currentVideoIndex !== null) {
      const videoEle = document.getElementById(
        "video-controll"
      ) as HTMLVideoElement | null;
      const sourceEle = document.getElementById(
        "video-source"
      ) as HTMLVideoElement | null;
      if (videoEle && sourceEle && videos[index]?.video_url) {
        sourceEle.src = videos[index].video_url;
        videoEle.load();
        videoEle.play();
      }
    }
  };

  const fetchVideos = (requestObject: any) => {
    fetchTrainingVideos(requestObject).then((res: any) => {
      if (res?.data?.length) {
        setAllVideos(res.data);
      } else {
        setAllVideos([]);
      }
    });
  };

  function titleCase(string: string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
  }

  useEffect(() => {
    if (allVideos?.length && planPermissions?.length) {
      const trainingVideos: any[] = [];
      allVideos.forEach((eachVideo: any) => {
        trainingVideos.push({
          ...eachVideo,
          hasPermission: true,
          // hasPermission: eachVideo.subscription_permission ?
          //   checkSubscriptionPermission(
          //     eachVideo.subscription_permission,
          //     planPermissions,
          //     -1
          //   ) : true
        });
      });
      setVideos(trainingVideos);
    } else {
      setVideos([]);
    }
  }, [allVideos, planPermissions]);

  useEffect(() => {
    if (currentVideoIndex !== null) {
      const videoEle = document.getElementById("video-controll");
      if (videoEle) {
        videoEle.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [currentVideoIndex]);

  useEffect(() => {
    if (currentVideoIndex !== null) {
      const videoEle = document.getElementById("video-controll");
      if (videoEle) {
        videoEle.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [currentVideoIndex]);

  useEffect(() => {
    onClickSearch();
  }, [searchText]);

  return (
    <Fragment>
      <div className="flex flex-row w-full h-full overflow-y-auto">
        <div className="flex flex-col w-full py-6 px-8">
          {false && currentVideoIndex === null ? (
            <div className="flex flex-row w-full items-center justify-between gap-10 mb-4">
              <div
                className="flex flex-col justify-between w-full bg-white rounded-lg shadow-md h-24 p-4 cursor-pointer"
                onClick={() => {
                  handleHelp(0);
                }}
              >
                <div className="flex flex-row w-full font-bold justify-between items-center">
                  <div>Knowledge Base</div>
                  <img
                    src="assets/icons/open-in-new.svg"
                    alt=" "
                    className="w-4"
                  />
                </div>
                <div className="flex flex-row w-full text-sm">
                  Browse through our collection of articles, user guides and
                  FAQs.
                </div>
              </div>
              <div
                className="flex flex-col justify-between w-full bg-white rounded-lg shadow-md h-24 p-4 cursor-pointer"
                onClick={() => {
                  handleHelp(1);
                }}
              >
                <div className="flex flex-row w-full font-bold justify-between items-center">
                  <div>Tickets</div>
                  <img
                    src="assets/icons/open-in-new.svg"
                    alt=" "
                    className="w-4"
                  />
                </div>
                <div className="flex flex-row w-full text-sm">
                  View your previous tickets; know their statuses and solutions.
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="flex flex-row w-full items-center justify-start my-4">
            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder={t("Search")}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  onClickSearch();
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton onClick={onClickSearch} edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton onClick={onClickCancel} edge="end">
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
          </div>
          {currentVideoIndex !== null &&
          videos[currentVideoIndex]?.video_url ? (
            <div className="flex flex-col w-full items-start justify-start mt-4 mb-8">
              <div className="w-full flex flex-row mb-4 text-sm items-center justify-start text-gray-500">
                <img
                  onClick={() => {
                    setCurrentVideoIndex(null);
                  }}
                  src="assets/icons/arrow-left.svg"
                  alt=" "
                  className="cursor-pointer w-6 mr-4"
                />
                Resources / {titleCase(videos[currentVideoIndex].main_module)}
              </div>
              <div className="flex flex-row w-full items-center justify-start">
                <video
                  className="w-full rounded-lg"
                  id="video-controll"
                  autoPlay
                  controls
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source
                    src={videos[currentVideoIndex].video_url}
                    id="video-source"
                  />
                </video>
              </div>
              <div className="mt-4 ml-4 w-full font-bold">
                {videos[currentVideoIndex].name}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="flex flex-wrap w-full items-center justify-start gap-x-8 gap-y-10 pb-10">
            {videos.map((eachVideo: any, index: any) => (
              <React.Fragment key={index}>
                <div className="flex flex-col justify-start pw-video-thumbnail h-24 py-4">
                  <div
                    className="w-80 relative"
                    onClick={() => {
                      eachVideo.hasPermission
                        ? onSelectVideo(index)
                        : setOpenUpgradeDialog(true);
                    }}
                  >
                    <img
                      className={`cursor-pointer pw-video-thumbnail-image rounded-lg shadow-sm ${
                        !eachVideo.hasPermission && "blur-sm"
                      }`}
                      src={eachVideo.thumbnail_url}
                      alt="PlanetWise"
                    />
                    {!eachVideo.hasPermission ? (
                      <span className="cursor-pointer absolute top-1/2 left-1/2 pw-upgrade-text whitespace-nowrap font-bold">
                        Upgrade subscription to access
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    onClick={() => {
                      eachVideo.hasPermission
                        ? onSelectVideo(index)
                        : setOpenUpgradeDialog(true);
                    }}
                    className="flex flex-row w-full text-sm mt-2 cursor-pointer"
                  >
                    {eachVideo.name}
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <UpgradeMessageDialog
        open={openUpgradeDialog}
        onClose={() => {
          setOpenUpgradeDialog(false);
        }}
      />
    </Fragment>
  );
};

export default TrainingVideo;
